<div class="page-container">
  <h2 class="page-title">Incident Communications</h2>
  <!-- TODO CHECK OR CREATE NEW PERMISSIONS FOR INCIDENT COMMUNICATIONS -->
  @if (permissionService.can_read_service_config$ | async ) {
  <div class="body">
    @if (isIncidentsLoading) {
    <div class="loading-container">
      <nx-spinner size="large"></nx-spinner>
    </div>
    } @else {
    <div class="kanban-board">

      <div class="kanban-column open-column">
        <div class="column-header">
          <div class="column-header-content">
            <h3 class="column-title">OPEN</h3>
            <p class="column-subtitle">Pending first communication</p>
          </div>
          <span class="column-count">{{ openIncidents.length }}</span>
        </div>
        <div class="column-content">
          @for (incident of openIncidents; track incident.pagerDutyIncidentId) {
          <div class="incident-card">
            <div class="incident-content">
              <div class="incident-field primary-field">
                <span class="field-label">SIM ID:</span>
                <span class="field-value">{{ incident.simTicketId  || 'N/A'  }}</span>
              </div>
              <div class="incident-field">
                <span class="field-label">Application:</span>
                <span class="field-value">{{ incident.applicationName }}</span>
              </div>
              @if (incident.incidentEnvironmentCode) {
              <div class="incident-field">
                <span class="field-label">Environment:</span>
                <span class="field-value">{{ incident.incidentEnvironmentCode }}</span>
              </div>
              }
              <div class="incident-field">
                <span class="field-label">Priority:</span>
                <span class="field-value priority-{{ incident.priorityCode?.toLowerCase() }}">{{ incident.priorityCode || 'N/A' }}</span>
              </div>
              <div class="incident-field">
                <span class="field-label">Start Time:</span>
                <span class="field-value">{{ incident.incidentStartDateTime ? (incident.incidentStartDateTime | date: 'medium') : 'N/A' }}</span>
              </div>
              <div class="incident-field">
                <span class="field-label">Comm. counter:</span>
                <span class="field-value">{{ incident.incidentCommunicationCounter }}</span>
              </div>
            </div>
            <div class="incident-actions">
              <span class="last-update-inline">
                <span class="last-update-label">Last update:</span>
                <span class="last-update-value">{{ incident.lastUpdateDateTime ? ((incident.lastUpdateDateTime | date: 'dd/MM/yyyy, HH:mm') + (incident.lastUpdatedby ? ' by ' + incident.lastUpdatedby : '')) : '----' }}</span>
              </span>
              <button nxButton="small" type="button" class="action-btn action-btn-open"
                      (click)="onViewIncident(incident.pagerDutyIncidentId)"
                      title="Prepare first communication">
                First Communication
              </button>
            </div>
          </div>
          } @empty {
          <div class="empty-column">No open incidents</div>
          }
        </div>
      </div>

      <div class="kanban-column ongoing-column">
        <div class="column-header">
          <div class="column-header-content">
            <h3 class="column-title">ONGOING</h3>
            <p class="column-subtitle">Communication in progress</p>
          </div>
          <span class="column-count">{{ ongoingIncidents_display.length }}</span>
        </div>
        <div class="column-content">
          @for (incident of ongoingIncidents_display; track incident.pagerDutyIncidentId) {
          <div class="incident-card">
            <div class="incident-content">
              <div class="incident-field primary-field">
                <span class="field-label">SIM ID:</span>
                <span class="field-value">{{ incident.simTicketId }}</span>
              </div>
              <div class="incident-field">
                <span class="field-label">Application:</span>
                <span class="field-value">{{ incident.applicationName }}</span>
              </div>
              @if (incident.incidentEnvironmentCode) {
              <div class="incident-field">
                <span class="field-label">Environment:</span>
                <span class="field-value">{{ incident.incidentEnvironmentCode }}</span>
              </div>
              }
              <div class="incident-field">
                <span class="field-label">Priority:</span>
                <span class="field-value priority-{{ incident.priorityCode?.toLowerCase() }}">{{ incident.priorityCode || 'N/A' }}</span>
              </div>
              <div class="incident-field">
                <span class="field-label">Start Time:</span>
                <span class="field-value">{{ incident.incidentStartDateTime ? (incident.incidentStartDateTime | date: 'medium') : 'N/A' }}</span>
              </div>
              <div class="incident-field">
                <span class="field-label">Comm. counter:</span>
                <span class="field-value">{{ incident.incidentCommunicationCounter }}</span>
              </div>
            </div>
            <div class="incident-actions">
              <span class="last-update-inline">
                <span class="last-update-label">Last update:</span>
                <span class="last-update-value">{{ incident.lastUpdateDateTime ? ((incident.lastUpdateDateTime | date: 'dd/MM/yyyy, HH:mm') + (incident.lastUpdatedby ? ' by ' + incident.lastUpdatedby : '')) : '----' }}</span>
              </span>
              <button nxButton="small" type="button" class="action-btn action-btn-ongoing"
                      (click)="onViewIncident(incident.pagerDutyIncidentId)"
                      title="Update communication">
                Update Communication
              </button>
            </div>
          </div>
          } @empty {
          <div class="empty-column">No ongoing incidents</div>
          }
        </div>
      </div>

      <div class="kanban-column resolved-column">
        <div class="column-header">
          <div class="column-header-content">
            <h3 class="column-title">RESOLVED</h3>
            <p class="column-subtitle">Waiting resolution communication</p>
          </div>
          <span class="column-count">{{ resolvedIncidents.length }}</span>
        </div>
        <div class="column-content">
          @for (incident of resolvedIncidents; track incident.pagerDutyIncidentId) {
          <div class="incident-card">
            <div class="incident-content">
              <div class="incident-field primary-field">
                <span class="field-label">SIM ID:</span>
                <span class="field-value">{{ incident.simTicketId }}</span>
              </div>
              <div class="incident-field">
                <span class="field-label">Application:</span>
                <span class="field-value">{{ incident.applicationName }}</span>
              </div>
              @if (incident.incidentEnvironmentCode) {
              <div class="incident-field">
                <span class="field-label">Environment:</span>
                <span class="field-value">{{ incident.incidentEnvironmentCode }}</span>
              </div>
              }
              <div class="incident-field">
                <span class="field-label">Priority:</span>
                <span class="field-value priority-{{ incident.priorityCode?.toLowerCase() }}">{{ incident.priorityCode || 'N/A' }}</span>
              </div>
              <div class="incident-field">
                <span class="field-label">Start Time:</span>
                <span class="field-value">{{ incident.incidentStartDateTime ? (incident.incidentStartDateTime | date: 'medium') : 'N/A' }}</span>
              </div>
              <div class="incident-field">
                <span class="field-label">Comm. counter:</span>
                <span class="field-value">{{ incident.incidentCommunicationCounter }}</span>
              </div>
            </div>
            <div class="incident-actions">
              <span class="last-update-inline">
                <span class="last-update-label">Last update:</span>
                <span class="last-update-value">{{ incident.lastUpdateDateTime ? ((incident.lastUpdateDateTime | date: 'dd/MM/yyyy, HH:mm') + (incident.lastUpdatedby ? ' by ' + incident.lastUpdatedby : '')) : '----' }}</span>
              </span>
              <button nxButton="small" type="button" class="action-btn action-btn-resolved"
                      (click)="onViewIncident(incident.pagerDutyIncidentId)"
                      title="Send resolution communication">
                Resolution Communication
              </button>
            </div>
          </div>
          } @empty {
          <div class="empty-column">No resolved incidents</div>
          }
        </div>
      </div>

      <div class="kanban-column closed-column">
        <div class="column-header">
          <div class="column-header-content">
            <h3 class="column-title">CLOSED</h3>
            <p class="column-subtitle">Will be purged after 24h</p>
          </div>
          <span class="column-count">{{ closedIncidents.length }}</span>
        </div>
        <div class="column-content">
          @for (incident of closedIncidents; track incident.pagerDutyIncidentId) {
          <div class="incident-card">
            <div class="incident-content">
              <div class="incident-field primary-field">
                <span class="field-label">SIM ID:</span>
                <span class="field-value">{{ incident.simTicketId }}</span>
              </div>
              <div class="incident-field">
                <span class="field-label">Application:</span>
                <span class="field-value">{{ incident.applicationName }}</span>
              </div>
              @if (incident.incidentEnvironmentCode) {
              <div class="incident-field">
                <span class="field-label">Environment:</span>
                <span class="field-value">{{ incident.incidentEnvironmentCode }}</span>
              </div>
              }
              <div class="incident-field">
                <span class="field-label">Priority:</span>
                <span class="field-value priority-{{ incident.priorityCode?.toLowerCase() }}">{{ incident.priorityCode || 'N/A' }}</span>
              </div>
              <div class="incident-field">
                <span class="field-label">Start Time:</span>
                <span class="field-value">{{ incident.incidentStartDateTime ? (incident.incidentStartDateTime | date: 'medium') : 'N/A' }}</span>
              </div>
              <div class="incident-field">
                <span class="field-label">Comm. counter:</span>
                <span class="field-value">{{ incident.incidentCommunicationCounter }}</span>
              </div>
              @if (incident.timeUntilRemoval) {
              <div class="incident-field time-remaining-field">
                <span class="field-label">Purged in:</span>
                <span class="field-value time-remaining">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"  style="vertical-align: text-bottom; margin-right: 4px;">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                  {{ incident.timeUntilRemoval }}
                </span>
              </div>
              }
            </div>
            <div class="incident-actions">
              <span class="last-update-inline">
                <span class="last-update-label">Last update:</span>
                <span class="last-update-value">{{ incident.lastUpdateDateTime ? ((incident.lastUpdateDateTime | date: 'dd/MM/yyyy, HH:mm') + (incident.lastUpdatedby ? ' by ' + incident.lastUpdatedby : '')) : '----' }}</span>
              </span>
            </div>
          </div>
          } @empty {
          <div class="empty-column">No closed incidents</div>
          }
        </div>
      </div>
    </div>

    @if (nextPageToken) {
    <div class="load-more-container">
      <button nxButton="primary"
              type="button"
              [disabled]="isLoadingMore"
              (click)="loadMoreIncidents()">
        @if (isLoadingMore) {
        <nx-spinner size="small"></nx-spinner>
        Loading...
        } @else {
        Load More Incidents
        }
      </button>
    </div>
    }
    }
  </div>
  <!-- TODO CHECK OR CREATE NEW PERMISSIONS FOR INCIDENT COMMUNICATIONS -->
  } @else if ((permissionService.can_read_service_config$ | async) === false) {
  <nx-message context="error">
    <span class="nx-font-weight-bold">Error</span><br />
    You don't have access to this application. Please contact your administrator.
  </nx-message>
  }
</div>